import React, { Component } from 'react';
export default class Msg extends Component {
    render() {
      return (
        <div className="msg" dangerouslySetInnerHTML={{ __html: this.props.text?this.props.text.replace(/(\r\n)|(\n)/g,'<br>'): '' }}/>
      );
    }
}